import { Card, CardContent } from "@/components/ui/card";
import { Users, Clock, CalendarDays } from "lucide-react";

const ForWhom = () => {
  const audience = [
    {
      icon: Users,
      title: "Quer sair da monotonia",
      description: "Você está cansado de comer sempre a mesma coisa e quer variedade sem gastar mais no mercado.",
    },
    {
      icon: Clock,
      title: "Precisa de almoço rápido",
      description: "Não tem muito tempo para cozinhar e não domina técnicas complexas na cozinha.",
    },
    {
      icon: CalendarDays,
      title: "Busca organização",
      description: "Quer planejar a semana com antecedência e reduzir idas desnecessárias ao mercado.",
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            Para quem é este e-book
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Perfeito para quem busca praticidade e variedade no dia a dia
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-3 max-w-5xl mx-auto">
          {audience.map((item, index) => {
            const Icon = item.icon;
            return (
              <Card 
                key={index}
                className="border-2 text-center hover:border-primary/50 transition-all duration-300 hover:shadow-soft animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="pt-8 pb-6">
                  <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-gradient-warm">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="mb-3 text-xl font-bold">{item.title}</h3>
                  <p className="text-muted-foreground">{item.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ForWhom;
